//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/BaseCreator.js";
import "../no/ObjectSelector.js";
import "../no/ObjectTypeSelector.js";
import "../no/ObjectSelector.js";
import "../no/ObjectTypeSelector.js";
let d=[[[0,"ExportFrom",1,0],[1,"ExportSelectionBlock",0,"ObjectSelector",0],[0,"FlattenAssembly",1,0],[0,"HeaderInformation",1,1],[0,"InputFile",1,0],[1,"ObjectTypes",0,"ObjectTypeSelector",0],[0,"ParasolidVersion",1,0]],[],[]];
SPLM.ParasolidExporter = class extends SPLM.BaseCreator{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.ParasolidExporter";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.ParasolidExporter.ExportFromOption = Object.freeze({
    "DisplayedPart" : "DisplayedPart", "ExistingPart" : "ExistingPart"});

SPLM.ParasolidExporter.ParasolidVersionOption = Object.freeze({
    "Current" : "Current", "Ps361Nx2406" : "Ps361Nx2406", "Ps360Nx2312" : "Ps360Nx2312", "Ps351Nx2306" : "Ps351Nx2306", "Ps350Nx2212" : "Ps350Nx2212", "Ps341Nx2206" : "Ps341Nx2206", "Ps340Nx2007" : "Ps340Nx2007", "Ps331Nx1980" : "Ps331Nx1980", "Ps330Nx1953" : "Ps330Nx1953", "Ps320Nx1899" : "Ps320Nx1899", "Ps310Nx1847" : "Ps310Nx1847", "Ps301Nx120" : "Ps301Nx120", "Ps280Nx110" : "Ps280Nx110", "Ps270Nx100" : "Ps270Nx100", "Ps260Nx90" : "Ps260Nx90", "Ps250Nx85" : "Ps250Nx85", "Ps240Nx80" : "Ps240Nx80", "Ps221Nx75" : "Ps221Nx75", "Ps220Nx70" : "Ps220Nx70", "Ps190Nx60" : "Ps190Nx60", "Ps180Nx50" : "Ps180Nx50", "Ps170Nx40" : "Ps170Nx40", "Ps160Nx30" : "Ps160Nx30", "Ps150Nx20" : "Ps150Nx20", "Ps140Nx10" : "Ps140Nx10", "Ps130Ug180" : "Ps130Ug180", "Ps120Ug170" : "Ps120Ug170", "Ps110Ug160" : "Ps110Ug160", "Ps100Ug150" : "Ps100Ug150", "Ps91Ug140" : "Ps91Ug140", "Ps90Ug130" : "Ps90Ug130", "Ps80Ug120" : "Ps80Ug120", "Ps71Ug111" : "Ps71Ug111", "Ps70Ug110" : "Ps70Ug110"});

export default SPLM;